import { DocumentId, EndpointQueryParameters } from '../../../../types/strapi/strapi'
import { Zones } from '../../../../types/api/print-queue-entry'
import { RewindJobStatuses } from '../../../../types/api/rewind-job'
import { materialRequirementsPopulate } from '../../flexo/constants/shipment-populate'

export const rewinderMachinesQuery: EndpointQueryParameters = {
    filters: {
        machine_type: {
            name: { $eq: 'rewinder' },
        },
    },
    populate: {
        machine_type: true,
    },
    pagination: { pageSize: 500, page: 1 },
}

const shipmentPopulate = {
    client: true,
    shipment_positions: true,
    print_job: { populate: { print_job_executors: true } },
    calculated: true,
    calculatedOnActual: true,
    materialRequirements: { populate: materialRequirementsPopulate },
    stamp: { populate: { roller: true } },
    virtualStamp: { populate: { roller: true } },
    blankPreviewFiles: true,
    rewind_jobs: { fields: ['copies', 'jobStatus'] },
}

export const rewindJobsQuery: EndpointQueryParameters = {
    filters: {
        jobStatus: { $eq: RewindJobStatuses.Created },
    },
    sort: ['shipment.clientDeliveryDate:desc'],
    populate: {
        shipment: {
            populate: shipmentPopulate,
        },
    },
    pagination: { pageSize: 1000, page: 1 },
}

export const rewindQueueEntriesPopulate: EndpointQueryParameters['populate'] = {
    machine: true,
    rewind_job: {
        populate: {
            rewind_job_executors: true,
            shipment: {
                populate: shipmentPopulate,
            },
        },
    },
}

export function getRewindQueueQuery(
    machineDocId: DocumentId,
    zone: Zones = Zones.Main
): EndpointQueryParameters {
    return {
        filters: {
            zone: { $eq: zone },
            machine: {
                documentId: { $eq: machineDocId },
            },
        },
        sort: ['sort:asc'],
        populate: rewindQueueEntriesPopulate,
        pagination: { pageSize: 500, page: 1 },
    }
}
